import { render, staticRenderFns } from "./SelectConfirmAssessmentSectionRules.vue?vue&type=template&id=2b5fb296"
import script from "./SelectConfirmAssessmentSectionRules.vue?vue&type=script&lang=js"
export * from "./SelectConfirmAssessmentSectionRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports